var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTop1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84846 13.5498C7.28813 13.4338 8.73442 13.4338 10.1741 13.5498C10.9581 13.5955 11.7383 13.6936 12.5099 13.8434C14.1796 14.1815 15.2697 14.7331 15.7368 15.6228C16.0877 16.3171 16.0877 17.1437 15.7368 17.8381C15.2697 18.7278 14.2229 19.3149 12.4926 19.6174C11.7216 19.7729 10.9412 19.874 10.1568 19.9199C9.43008 20 8.70338 20 7.96802 20H6.64438C6.36754 19.9644 6.09935 19.9466 5.83981 19.9466C5.05538 19.9063 4.27477 19.8082 3.50397 19.653C1.83428 19.3327 0.744223 18.7633 0.277055 17.8737C0.0967112 17.529 0.00163408 17.144 0.000104218 16.7527C-0.00354431 16.3589 0.0886575 15.9705 0.268404 15.6228C0.72692 14.7331 1.81698 14.1548 3.50397 13.8434C4.27816 13.6915 5.06144 13.5934 5.84846 13.5498ZM8.00263 0C10.9028 0 13.2539 2.41782 13.2539 5.40036C13.2539 8.38289 10.9028 10.8007 8.00263 10.8007C5.10241 10.8007 2.75131 8.38289 2.75131 5.40036C2.75131 2.41782 5.10241 0 8.00263 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop1);
export default __webpack_public_path__ + "static/media/top1.6fc6c1f0038c9a8622b30090cf66d447.svg";
export { ForwardRef as ReactComponent };